<template>
  <Modal v-model="clickJumpModal" :title="$t('key1005054')" width="500"
    :transfer="false" :mask-closable="false" @on-visible-change="clickJumpChange">
    <Form ref="clickJumpForm" :model="clickJumpForm" :rules="ruleValidate" :label-width="100" @submit.native.prevent>
      <Row style="width: 85%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1005055')" prop="jumpTargetType">
            <Select v-model="clickJumpForm.jumpTargetType" transfer @on-change="selectChange">
              <Option v-for="item in jumpTargetTypeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
            </Select>
          </FormItem>
        </Col>
        <template v-if="clickJumpForm.jumpTargetType !== null">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="clickJumpForm.jumpTargetType !== 3">
            <Form-item :label="$t('key1005056')" prop="jumpTargetValue" class="required_style_label">
              <!--活动-->
              <Select v-model="clickJumpForm.jumpTargetValue" transfer v-if="clickJumpForm.jumpTargetType === 0">
                <Option v-for="item in activityList" :key="item.ymsActivityPlanId" :value="item.ymsActivityPlanId">{{ item.activityTitle }}</Option>
              </Select>
              <!--指定链接-->
              <Input v-model.trim="clickJumpForm.jumpTargetValue" clearable v-if="clickJumpForm.jumpTargetType === 1"></Input>
              <!-- 分类-->
              <vueTreeSelect
                v-if="clickJumpForm.jumpTargetType === 2"
                v-model="clickJumpForm.jumpTargetValue"
                :clearable="true"
                :searchable="true"
                :openOnFocus="true"
                :closeOnSelect="true"
                :noResultsText="$t('key1000102')"
                :noOptionsText="$t('key1000375')"
                :placeholder="$t('key1000101')"
                :normalizer="normalizer"
                :options="ymsProductCategoryList">
                <template #option-label="{ node, labelClassName }">
                  <label
                    :class="labelClassName"
                    :title="node.label">
                    {{ node.label }}
                  </label>
                </template>
              </vueTreeSelect>
            </Form-item>
          </Col>
        </template>
      </Row>
    </Form>
    <template #footer>
      <Button @click="clickJumpModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="clickJumpBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import vueTreeSelect from '@riophae/vue-treeselect';
import {_handleMultilingualFields, getCloudTreeData, getDataSetBatchList, getEnumList} from "@/utils/common";

export default {
  name: "clickJumpModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      clickJumpModal: false,
      clickJumpForm: {
        jumpTargetType: null,
        jumpTargetValue: null
      },
      ruleValidate: {
        jumpTargetType: [
          {
            required: true,
            type: 'number',
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005050'),
            trigger: 'change'
          }
        ],
        jumpTargetValue: [
          {
            type: 'number',
            validator: v.validateJumpTargetValue(),
            trigger: 'blur'
          }
        ]
      },
      activityList: [],
      ymsProductCategoryList: [],
      enumData: []
    };
  },
  computed: {
    // 跳转目标类型
    jumpTargetTypeList() {
      const ENUM_KEY = 'YmsAdvertisementDetailJumpTargetTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    }
  },
  methods: {
    // 初始化数据
    initFun(obj) {
      let jumpTargetType = null;
      let jumpTargetValue = null;
      if (obj) {
        jumpTargetType = obj.jumpTargetType;
        jumpTargetValue = obj.jumpTargetValue;
      }
      (async () => {
        let enumKeyList = ['YmsAdvertisementDetailJumpTargetTypeCoreEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await this.getOngoingActivities();
        await this.getCloudSalesClassification();
        this.clickJumpForm.jumpTargetType = jumpTargetType;
        this.clickJumpForm.jumpTargetValue = jumpTargetValue;
        this.clickJumpModal = true;
      })();
    },
    // 获取正在进行中的活动数据
    getOngoingActivities() {
      let v = this;
      v.axios.get(api.get_ymsActivityPlan_shopping).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            data.map((item) => {
              for (let key in item) {
                if (['activityGoodsLabel', 'activitySlogan', 'activityTitle'].includes(key)) {
                  handleData(item, key);
                }
              }
            });
          }
          v.activityList = data;
        }
      });

      function handleData(item, fields) {
        item[fields] = _handleMultilingualFields(item[fields]);
      }
    },
    // 获取云卖分类的数据
    getCloudSalesClassification() {
      getCloudTreeData(api.post_ymsProductCategory_queryAll, 'tile').then((data) => {
        this.ymsProductCategoryList = data;
      });
    },
    // 确定按钮
    clickJumpBtn() {
      let v = this;
      // 校验链接地址必须是https 或者http 开头
      if (v.clickJumpForm.jumpTargetType === 1) {
        let reg = v.$regular.checkHttps;
        let url = v.clickJumpForm.jumpTargetValue;
        if (!reg.test(url)) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005051'));
          return false;
        }
      }
      if (v.clickJumpForm.jumpTargetType === 3) {
        v.clickJumpForm.jumpTargetValue = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005052');
      }
      v.$refs['clickJumpForm'].validate((valid) => {
        if (valid) {
          v.clickJumpModal = false;
          let obj = {
            activityList: v.activityList,
            ymsProductCategoryList: v.ymsProductCategoryList
          };
          v.$emit('updateData', Object.assign({}, v.clickJumpForm, obj));
        }
      });
    },
    // 监听弹窗
    clickJumpChange(value) {
      if (!value) {
        this.$refs['clickJumpForm'].resetFields();
      }
    },
    // 校验跳转目标
    validateJumpTargetValue() {
      return function (rule, value, callback) {
        if (!value) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005053')));
        }
        callback();
      };
    },
    // 选择跳转目标类型
    selectChange() {
      this.clickJumpForm.jumpTargetValue = null;
    }
  },
  components: {
    vueTreeSelect
  }
};
</script>

<style scoped>

</style>